import logo from "./lawyerLogo.png";
import coatIcon from "./coatIcon.png"
import icn_Dashboard from "./dashboard.svg";
import icn_Lawyer from "./lawyerIcon.svg";
import icn_Advocate from "./lawyerIcon.svg";
import icn_Requests from "./request.svg";
import icn_Complaints from "./complaints.svg";
import logout from "./logoutIcon.svg";
import notification from "./notificationbellIcon.svg";
import downloadReport from "./downloadReport.svg";
import actionDots from "./actionDot.svg";
import warningIcon from "./warningIcon.svg";
import actionViewIcon from "./actionViewIcon.svg";
import playButton from "./playButton.svg";
import whatsappIcon from "./whatsappIcon.svg";
import mailImage from "./mailImage.svg";
import icn_Customer from "./customer.svg";
import userIcon from "./user.svg";
import icn_Support from "./support.svg";
import icn_Consultations from "./consultation.svg";
import completeConsultationIcon from "./completeConsultationIcon.svg";
import upcomingConsultationIcon from "./upcomingConsultationIcon.svg";
import cancelConsultationIcon from "./cancelConsultationIcon.svg";
import totalConsultationIcon from "./toatalConsultationIcon.svg";
import consultationAmountIcon from "./consultationAmount.svg";
import revenueIcon from "./revenueIcon.svg";
import gstIcon from "./gstIcon.svg";
import icn_Config from "./config.svg";
import icn_Transactions from "./transaction.svg";
import icn_Coupon from "./coupon.svg";
import icn_Penalty from "./penalty.svg";
import icn_GstInvoice from "./gst_invoice.svg";
import penaltyIcon from"./penaltyIcon.svg";
import refundIcon from "./refundIcon.svg";
import lawyerFees from "./lawyerFeesIcon.svg";
import consultationIcon from "./consultationIcon.svg";
import cancelled from "./cancelled.png";
import icn_User from "./usersidebar.svg";
import icn_AccessController from "./access-control.svg";
export{
    logo,
    coatIcon,
    icn_Dashboard,
    icn_Lawyer,
    icn_Advocate,
    logout,
    notification,
    downloadReport,
    actionDots,
    warningIcon,
    actionViewIcon,
    playButton,
    whatsappIcon,
    mailImage,
    userIcon,
    completeConsultationIcon,
    upcomingConsultationIcon,
    cancelConsultationIcon,
    totalConsultationIcon,
    consultationAmountIcon,
    revenueIcon,
    gstIcon,
    icn_Transactions,
    penaltyIcon,
    refundIcon,
    lawyerFees,
    consultationIcon,
    cancelled,
    icn_User,
    icn_AccessController
};
export const sideMenuIcon={
    icn_Dashboard,
    icn_Advocate,
    icn_Requests,
    icn_Complaints,
    icn_Customer,
    icn_Support,
    icn_Consultations,
    icn_Transactions,
    icn_GstInvoice,
    icn_Penalty,
    icn_Coupon,
    icn_User,
    icn_Config,
    icn_AccessController,
};